import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { getPcMainScrollElement } from "./main-simplebar.js";

gsap.registerPlugin(ScrollTrigger);

/** PC（768px〜）では SimpleBar の実スクロール要素。ScrollTrigger の scroller に渡す */
function getScrollTriggerScroller() {
  return getPcMainScrollElement();
}

/** お悩みビジュアルの吹き出しゆらぎ（TOP / サービス共通） */
function worryBubbleWobbleReduceMotion() {
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function playWorryBubbleWobble(bubbleEl) {
  if (!bubbleEl || worryBubbleWobbleReduceMotion()) return;
  gsap.killTweensOf(bubbleEl);
  gsap.set(bubbleEl, { rotation: 0, transformOrigin: '52% 55%', force3D: true });
  gsap.to(bubbleEl, {
    keyframes: [
      { rotation: -5, duration: 0.12, ease: 'sine.out' },
      { rotation: 4.5, duration: 0.13, ease: 'sine.inOut' },
      { rotation: -3, duration: 0.11, ease: 'sine.inOut' },
      { rotation: 2, duration: 0.09, ease: 'sine.inOut' },
      { rotation: 0, duration: 0.25, ease: 'sine.out' },
    ],
  });
}

function bindWorryBubbleScrollWobble(bubbleEl) {
  if (!bubbleEl) return;
  const scroller = getScrollTriggerScroller();
  var play = function () {
    playWorryBubbleWobble(bubbleEl);
  };
  ScrollTrigger.create({
    trigger: bubbleEl,
    start: 'top 50%',
    ...(scroller ? { scroller: scroller } : {}),
    onEnter: play,
    onEnterBack: play,
  });
}

/** サービス: お悩みカードがビューに入るたび右→左へスライドイン（離脱で初期位置に戻して再入場で再生） */
function bindSvcWorriesCardsSlideIn() {
  var cards = document.querySelectorAll('.svcWorries__cards .svcWorries__card');
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  for (var i = 0; i < cards.length; i++) {
    (function (card) {
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[i]);
  }
}

/** サービス詳細カード: 悩み白ボックス全体が到達時に右→左へスライドイン（離脱でリセット） */
function bindSvcDetailWorriesSlideIn() {
  var boxes = document.querySelectorAll('.svcDetailCard__worriesBox');
  if (!boxes.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  var b;
  for (b = 0; b < boxes.length; b++) {
    (function (box) {
      var runSlideIn = function () {
        gsap.killTweensOf(box);
        gsap.fromTo(
          box,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetBox = function () {
        gsap.killTweensOf(box);
        gsap.set(box, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: box,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetBox,
        onLeaveBack: resetBox,
      });
    })(boxes[b]);
  }
}

/** サービス「運用の透明性」: 各カード全体が到達時に右→左へスライドイン（離脱でリセット） */
function bindSvcSystemCardsSlideIn() {
  var cards = document.querySelectorAll('.svcSystem__card');
  if (!cards.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();
  var c;
  for (c = 0; c < cards.length; c++) {
    (function (card) {
      var runSlideIn = function () {
        gsap.killTweensOf(card);
        gsap.fromTo(
          card,
          { x: 48, opacity: 0, force3D: true },
          { x: 0, opacity: 1, duration: 0.65, ease: 'power3.out', overwrite: 'auto' }
        );
      };
      var resetCard = function () {
        gsap.killTweensOf(card);
        gsap.set(card, { x: 48, opacity: 0 });
      };
      ScrollTrigger.create({
        trigger: card,
        start: 'top 50%',
        end: 'bottom top',
        ...(scroller ? { scroller: scroller } : {}),
        onEnter: runSlideIn,
        onEnterBack: runSlideIn,
        onLeave: resetCard,
        onLeaveBack: resetCard,
      });
    })(cards[c]);
  }
}

/**
 * サービス: サポート手順 — ①1→②2、②後に3を2に重ね③2到達で3を定位置へ。
 * ④4枚ある場合は3の完了後に4を3に重ね、⑤3到達で4を定位置へ。最後にデッキ解除。
 */
function bindSvcSupportListReveal() {
  var list = document.querySelector('.svcSupport__list');
  if (!list) return;
  var cards = list.querySelectorAll('.svcSupport__card');
  if (cards.length < 2) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;
  var scroller = getScrollTriggerScroller();

  var tops = [];
  var heights = [];
  var lefts = [];
  var widths = [];
  var i;
  for (i = 0; i < cards.length; i++) {
    tops.push(cards[i].offsetTop);
    heights.push(cards[i].offsetHeight);
    lefts.push(cards[i].offsetLeft);
    widths.push(cards[i].offsetWidth);
  }
  var stackTop = tops[0];
  var delta2 = tops[1] - stackTop;
  var totalH = tops[tops.length - 1] + heights[heights.length - 1];
  list.style.minHeight = totalH + 'px';
  list.classList.add('is-supportDeck');

  for (i = 2; i < cards.length; i++) {
    gsap.set(cards[i], { visibility: 'hidden' });
  }

  gsap.set(cards[1], {
    position: 'absolute',
    left: lefts[1],
    top: stackTop,
    y: 0,
    width: widths[1],
    zIndex: 4,
    force3D: true,
  });

  var dur = Math.min(1.12, Math.max(0.82, Math.abs(delta2) / 480));

  ScrollTrigger.create({
    trigger: cards[0],
    start: 'top 40%',
    once: true,
    ...(scroller ? { scroller: scroller } : {}),
    onEnter: function () {
      gsap.set(cards[1], { y: 0 });
      gsap.to(cards[1], {
        y: delta2,
        duration: dur,
        ease: 'power3.out',
        overwrite: 'auto',
        onComplete: function () {
          gsap.set(cards[1], { clearProps: 'position,top,left,width,zIndex,transform' });
          if (cards.length <= 2) {
            list.classList.remove('is-supportDeck');
            list.style.minHeight = '';
            return;
          }
          gsap.set(cards[1], { position: 'relative', zIndex: 6 });
          gsap.set(cards[2], { clearProps: 'visibility' });
          gsap.set(cards[2], {
            position: 'absolute',
            left: lefts[1],
            top: tops[1],
            y: 0,
            width: widths[1],
            zIndex: 4,
            force3D: true,
          });
          list.style.minHeight = totalH + 'px';

          var move3 = tops[2] - tops[1];
          var dur3 = Math.min(1.12, Math.max(0.82, Math.abs(move3) / 480));
          ScrollTrigger.create({
            trigger: cards[1],
            start: 'top 40%',
            once: true,
            ...(scroller ? { scroller: scroller } : {}),
            onEnter: function () {
              gsap.set(cards[2], { y: 0 });
              gsap.to(cards[2], {
                y: move3,
                duration: dur3,
                ease: 'power3.out',
                overwrite: 'auto',
                onComplete: function () {
                  gsap.set(cards[2], { clearProps: 'position,top,left,width,zIndex,transform' });
                  if (cards.length <= 3) {
                    list.classList.remove('is-supportDeck');
                    list.style.minHeight = '';
                    gsap.set(cards[1], { clearProps: 'position,zIndex' });
                    return;
                  }
                  gsap.set(cards[2], { position: 'relative', zIndex: 6 });
                  gsap.set(cards[3], { clearProps: 'visibility' });
                  gsap.set(cards[3], {
                    position: 'absolute',
                    left: lefts[2],
                    top: tops[2],
                    y: 0,
                    width: widths[2],
                    zIndex: 4,
                    force3D: true,
                  });
                  list.style.minHeight = totalH + 'px';

                  var move4 = tops[3] - tops[2];
                  var dur4 = Math.min(1.12, Math.max(0.82, Math.abs(move4) / 480));
                  ScrollTrigger.create({
                    trigger: cards[2],
                    start: 'top 40%',
                    once: true,
                    ...(scroller ? { scroller: scroller } : {}),
                    onEnter: function () {
                      gsap.set(cards[3], { y: 0 });
                      gsap.to(cards[3], {
                        y: move4,
                        duration: dur4,
                        ease: 'power3.out',
                        overwrite: 'auto',
                        onComplete: function () {
                          list.classList.remove('is-supportDeck');
                          list.style.minHeight = '';
                          gsap.set(cards[1], { clearProps: 'position,zIndex' });
                          gsap.set(cards[2], { clearProps: 'position,zIndex' });
                          gsap.set(cards[3], { clearProps: 'position,top,left,width,zIndex,transform' });
                        },
                      });
                    },
                  });
                  ScrollTrigger.refresh();
                },
              });
            },
          });
          ScrollTrigger.refresh();
        },
      });
    },
  });
  ScrollTrigger.refresh();
}

$(window).on("load", function () {

  // MV 全体をページ読み込み完了後にフェードイン（各ページのヒーロー一括）
  if (
    $('body').hasClass('p-top') ||
    $('body').hasClass('p-service') ||
    $('body').hasClass('p-company') ||
    $('body').hasClass('p-contact')
  ) {
    $('body').addClass('is-mvShown');
  }

  // TOP: MV フェード後 — 装飾ラインは CSS（.is-active で 40px ギャップが縦にループ）
  if ($('body').hasClass('p-top')) {
    var reduceDeco = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduceDeco) {
      var decoLineEl = document.querySelector('.topMv__decoLine');
      if (decoLineEl) {
        window.setTimeout(function () {
          decoLineEl.classList.add('is-active');
        }, 900);
      }
    }
  }

  var secCount = $('.js-sec-count').length +1;
  let sectionItem
  let navItem

  // for (let i = 1; i < 6; i++) {
  for (let i = 1; i < secCount; i++) {
    navItem = '.js-current-nav' + i
    sectionItem = '.js-current-sec' + i
    const navScroller = getScrollTriggerScroller();
    ScrollTrigger.create({
      trigger: sectionItem,
      start: 'top center',
      end: 'bottom center',
      ...(navScroller ? { scroller: navScroller } : {}),
      toggleClass: {
        targets: navItem,
        className: 'is-current',
      },
    });
  }

  if ($('body').hasClass('p-top') || $('body').hasClass('p-service')) {
    ScrollTrigger.refresh();
  }

  let stResizeTimer;
  $(window).on("resize", function () {
    clearTimeout(stResizeTimer);
    stResizeTimer = setTimeout(function () {
      ScrollTrigger.refresh();
    }, 250);
  });

  // 会社概要: 沿革タイムラインの縦線を上から下へ（Figma 264:3018 / 264:3059）
  const historyTimeline = document.querySelector('#sec-company-history .cmpHistory__timeline');
  if (historyTimeline) {
    let historyLinePlayed = false;
    const histScroller = getScrollTriggerScroller();
    ScrollTrigger.create({
      trigger: '#sec-company-history',
      start: 'top 82%',
      ...(histScroller ? { scroller: histScroller } : {}),
      onEnter: () => {
        if (historyLinePlayed) return;
        historyLinePlayed = true;
        historyTimeline.classList.add('is-lineVisible');
      },
    });
  }

  // 対応エリア: 地図ブロックが start〜end の間に入るたびマーカー強調（離れたら解除して再入場で再生）
  const areaMap = document.querySelector('.topArea__map');
  if (areaMap) {
    const areaMapMarker = areaMap.querySelector('.topArea__mapMarker');
    const areaMapMarkerLarge = areaMap.querySelector('.topArea__mapMarkerLarge');
    if (areaMapMarker || areaMapMarkerLarge) {
      const areaScroller = getScrollTriggerScroller();
      const areaMapMarkersActivate = function () {
        if (areaMapMarker) areaMapMarker.classList.add('is-active');
        if (areaMapMarkerLarge) areaMapMarkerLarge.classList.add('is-active');
      };
      const areaMapMarkersDeactivate = function () {
        if (areaMapMarker) areaMapMarker.classList.remove('is-active');
        if (areaMapMarkerLarge) areaMapMarkerLarge.classList.remove('is-active');
      };
      ScrollTrigger.create({
        trigger: areaMap,
        start: 'top 82%',
        end: 'bottom top',
        ...(areaScroller ? { scroller: areaScroller } : {}),
        onEnter: areaMapMarkersActivate,
        onEnterBack: areaMapMarkersActivate,
        onLeave: areaMapMarkersDeactivate,
        onLeaveBack: areaMapMarkersDeactivate,
      });
    }
  }

  // お悩み吹き出し: ビューに入るたびゆらぎ（下方向スクロール・上方向スクロールの再入場の両方）
  bindWorryBubbleScrollWobble(document.querySelector('.topWorries__bubble'));
  bindWorryBubbleScrollWobble(document.querySelector('.svcWorries__bubble'));

  bindSvcWorriesCardsSlideIn();
  bindSvcDetailWorriesSlideIn();
  bindSvcSystemCardsSlideIn();
  bindSvcSupportListReveal();
  if ($('body').hasClass('p-service')) {
    ScrollTrigger.refresh();
  }
});
